var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-item-group',{attrs:{"mandatory":""}},[_c('v-container',[_c('v-row',_vm._l((_vm.groups),function(group){return _c('Group',{key:group.name,attrs:{"group":group}})}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }